import { WestpacEnvironment } from 'global-types';

export const environment: WestpacEnvironment = {
  production: true,
  env: 'production',
  nydusNetworkApiBaseUrl: 'https://bom-nn.kaligo.com',
  translationBaseUrl: './assets/i18n',
  guardhouseApiUrl: 'https://myofferssso.bankofmelbourne.com.au',
  clientId: '9a3cf42c-d9ea-4c48-a5bc-df9196686089',
  connection: 'westpac',
  scope: 'openid,address,email,phone,profile,custom',
  redirectUri: 'https://myoffers.bankofmelbourne.com.au',
  stripeApiKey:
    'pk_live_51I3Ys9LXeLt2fiomdRC4oR5TXEARjEI5Lg5NzAO81980KWASiSJHE8DfiO5Zn91ELirdFg0IKG3P8w0eNF7qrmz300i3Ket73A',
  travelEdgeBaseUrl: 'https://myoffershotels.bankofmelbourne.com.au',
  brandName: 'Bank of Melbourne',
  shortBrandName: 'BOM',
  hermesMode: 'refresh-token-rotation',
  idleCheckConfig: {
    timeout: 600,
    promptTimeout: 120,
  },
  sessionCheckPollInterval: 180,
  sessionCheckRetryThreshold: 10,
  cookiesConfig: {
    localeCookieName: 'ascenda.locale',
    localeCookieDomain: 'bankofmelbourne.com.au',
  },
  appId: 'bf570250-be9a-4825-ad8b-b7df325e9700',
  unleashAppName: 'rd-bom-prod',
  unleashClientKey:
    '*:production.ed9dc866a8362d926412ad673806fed91176182036fdca279f983b42',
};
